<template>
  <div class="relative py-4 lg:static">
    <div class="pb-24">
      <div class="overflow-auto md:h-screen md:pb-60">
        <div class="mb-4 flex w-full items-center justify-between">
          <p class="font-bold text-grey-2">{{ $t('contracts.filters.title') }}</p>
          <p class="cursor-pointer text-sm font-semibold text-orange-1" @click="clear">
            {{ $t('contracts.filters.clear') }}
          </p>
        </div>
        <p class="mb-3 text-left text-sm font-semibold text-grey-3">
          {{ $t('contracts.filters.risk_title') }}
        </p>
        <div class="flex flex-wrap">
          <div v-for="(value, key) in $tm('contracts.filters.risk_options')" :key="key">
            <GeneralInput
              v-if="value !== ''"
              v-model:data="risk[key]"
              bold
              greenBg
              noBoxes
              type="checkbox"
              name="risk"
              class="cursor-pointer"
            >
              <template #label>
                <div class="no-highlight flex w-4 items-center justify-center">
                  {{ $tm('contracts.filters.risk_options.' + key) }}
                </div>
              </template>
            </GeneralInput>
          </div>
        </div>
        <!-- <p v-if="!onSettled" class="mb-3 text-left text-sm font-semibold text-grey-3">
          {{ $t('contracts.filters.payment_status_title') }}
        </p>
        <GeneralInput
          v-if="!onSettled"
          v-model:data="paymentStatus"
          separatedRadio
          bgColor="bg-grey-ghost"
          type="radio"
          name="status"
          :options="$tm('contracts.filters.payment_status_options')"
        /> -->
        <p class="mb-3 text-left text-sm font-semibold text-grey-3">
          {{ $t('contracts.filters.category_title') }}
        </p>
        <GeneralInput
          v-for="(value, key) in $tm('projects.category_options')"
          :key="key"
          v-model:data="categories[key]"
          bold
          type="checkbox"
          name="category"
          greenBg
          :label="value"
          class="mb-3 overflow-hidden rounded-2xl bg-grey-ghost p-4 hover:bg-green-5 hover:shadow-lg"
        />
      </div>
    </div>
    <div
      class="bottom-safe btn-contracts absolute bottom-0 w-full pb-12 lg:absolute lg:bottom-0 lg:pb-0 lg:pb-6"
    >
      <GpButton :disabled="!applicableFilters" class="mx-auto" @click="filter">
        {{ $t('contracts.filters.apply') }}
      </GpButton>
    </div>
  </div>
</template>

<script>
import { ref, computed } from 'vue'
import GeneralInput from '@/components/general/Input.vue'
import GpButton from '@/components/general/GpButton.vue'
import { useStore } from 'vuex'
import { watch } from 'vue'
export default {
  emits: ['filter'],
  components: {
    GeneralInput,
    GpButton,
  },
  setup(props, { emit }) {
    const store = useStore()

    const applicableFilters = computed(() => {
      // If no previous filters but something new was selected
      if (
        !previousFilters.value &&
        (paymentStatus.value !== null ||
          !checkNullProperties(risk.value) ||
          !checkNullProperties(categories.value)
          // !checkNullProperties(wallets.value)
          )
      )
        return true

      if (previousFilters.value) {
        if (JSON.stringify(previousFilters.value.risk) !== JSON.stringify(risk.value)) return true
        if (JSON.stringify(previousFilters.value.categories) !== JSON.stringify(categories.value))
          return true
        // if (JSON.stringify(previousFilters.value.wallets) !== JSON.stringify(wallets.value))
        //   return true
        if (paymentStatus.value !== previousFilters.value.paymentStatus) return true
      }

      return false
    })

    const checkNullProperties = (obj) => {
      for (const key in obj) {
        if (obj[key] !== null && obj[key] != '') return false
      }
      return true
    }

    const previousFilters = computed(() => {
      return store.state.contracts.filters
    })

    const paymentStatus = ref(
      previousFilters.value && previousFilters.value.paymentStatus
        ? previousFilters.value.paymentStatus
        : null
    )

    const risk = ref(
      previousFilters.value && previousFilters.value.risk
        ? previousFilters.value.risk
        : {
            0: false,
            4: false,
            5: false,
            6: false,
            7: false,
            8: false,
            9: false,
            10: false,
          }
    )

    const categories = ref(
      previousFilters.value && previousFilters.value.categories
        ? previousFilters.value.categories
        : {
            sustainable_energy: false,
            blue_economy: false,
            social_economy: false,
            business_in_transition: false,
            green_use_of_land: false,
          }
    )

    // const wallets = ref(
    //   previousFilters.value && previousFilters.value.wallets
    //     ? previousFilters.value.wallets
    //     : null
    // )
    // const walletsLabel = ref(null)
    // if (store.state.wallets.wallets) {
    //   if (!wallets.value) wallets.value = store.getters.getWalletsOptions()
    //   walletsLabel.value = store.getters.getWalletsLabels()
    // }

    const filter = () => {
      const filters = {
        paymentStatus: JSON.parse(JSON.stringify(paymentStatus.value)),
        risk: JSON.parse(JSON.stringify(risk.value)),
        categories: JSON.parse(JSON.stringify(categories.value)),
        // wallets: JSON.parse(JSON.stringify(wallets.value)),
      }
      store.dispatch('setContractFilters', filters)
      emit('filter')
      store.dispatch('setShowPopup', false)
    }

    const clear = () => {
      store.dispatch('setContractFilters', null)
      paymentStatus.value = null
      risk.value = {
        0: false,
        4: false,
        5: false,
        6: false,
        7: false,
        8: false,
        9: false,
        10: false,
      }
      categories.value = {
        sustainable_energy: false,
        blue_economy: false,
        social_economy: false,
        business_in_transition: false,
        green_use_of_land: false,
      }
      // wallets.value = store.getters.getWalletsOptions()

      emit('filter')
      store.dispatch('setShowPopup', false)
    }

    watch(
      () => previousFilters,
      () => {
        if (previousFilters.value == null) clear()
      },
      { deep: true }
    )

    const onSettled = computed(() => {
      return store.state.contracts.currentTab === 2
    })

    return {
      paymentStatus,
      filter,
      risk,
      clear,
      categories,
      // wallets,
      // walletsLabel,
      onSettled,
      applicableFilters,
    }
  },
}
</script>

<style scoped>
@media (max-width: 768px) {
  .bottom-save {
    bottom: calc(var(--sab));
  }
}

@media (min-width: 768px) {
  .btn-contracts {
    right: 0px;
    z-index: 50;
    background: white;
    z-index: 50;
  }
  .btn-contracts::after {
    content: '';
    background: linear-gradient(transparent, white);
    width: 100%;
    height: 3rem;
    left: 0;
    top: -3rem;
    pointer-events: none;
    position: absolute;
  }
}
</style>
